import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateICTData } from "../../../../../store/uiSlice";

const UpdateICTData = ({ record, onClose }) => {
  const dispatch = useDispatch();

  const [updatedData, setUpdatedData] = useState({
    ...record,
    vendorId: record?.vendorId ?? "",
  });

  const { ictData } = useSelector((state) => state.ui);
  const { domains = [] } = useSelector((state) => state.domains || {});
  const { vendors = [] } = useSelector((state) => state.vendors || {});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const updatedFilePath = `/static/ict_images/${file.name}`;
      setUpdatedData((prev) => ({ ...prev, ictImg: updatedFilePath }));
    }
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...updatedData,
        domainId: updatedData.domainId ? Number(updatedData.domainId) : null,
        vendorId: updatedData.vendorId ? Number(updatedData.vendorId) : null,
      };

      await dispatch(updateICTData(payload)).unwrap();
      toast.success("Record updated successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to update record.");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <ToastContainer position="bottom-right" autoClose={3000} />
        <h3>Update Record</h3>

        <form>
          <div className="form-group">
            <label>ICT Name</label>
            <input
              type="text"
              name="ictName"
              value={updatedData.ictName || ""}
              onChange={handleInputChange}
              list="ictNameSuggestions"
              autoComplete="off"
            />
            <datalist id="ictNameSuggestions">
              {ictData
                .filter((ict) =>
                  String(ict.ictName || "")
                    .toLowerCase()
                    .includes(String(updatedData.ictName || "").toLowerCase())
                )
                .map((ict) => (
                  <option key={ict.id} value={ict.ictName} />
                ))}
            </datalist>
          </div>

          <div className="form-group">
            <label>Detailed Description</label>
            <textarea
              name="ictDesc"
              value={updatedData.ictDesc || ""}
              rows="4"
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Short Description</label>
            <textarea
              name="ictSDesc"
              value={updatedData.ictSDesc || ""}
              rows="2"
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Course Type</label>
            <select
              name="ictType"
              value={updatedData.ictType || ""}
              onChange={handleInputChange}
            >
              <option value="Corporate Training">Corporate Training</option>
              <option value="Industrial Training">Industrial Training</option>
              <option value="Certificate Course">Certificate Course</option>
              <option value="Internship">Internship</option>
            </select>
          </div>

          <div className="form-group">
            <label>Domain</label>
            <select
              name="domainId"
              value={updatedData.domainId ?? ""}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Domain</option>
              {domains && domains.length > 0 ? (
                domains.map((domain) => (
                  <option key={domain.id} value={domain.id}>
                    {domain.domain}
                  </option>
                ))
              ) : (
                <option disabled>Loading Domains...</option>
              )}
            </select>
          </div>

          <div className="form-group">
            <label>Vendor</label>
            <select
              name="vendorId"
              value={updatedData.vendorId ?? ""}
              onChange={handleInputChange}
            >
              <option value="">Select Vendor (Optional)</option>
              {vendors && vendors.length > 0 ? (
                vendors.map((v) => (
                  <option key={v.id} value={v.id}>
                    {v.vendor}
                  </option>
                ))
              ) : (
                <option disabled>Loading Vendors...</option>
              )}
            </select>
          </div>

          <div className="form-group">
            <label>Image</label>
            <input
              type="file"
              name="ictImg"
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>

          <div className="form-buttons">
            <button type="button" className="fa fa-edit" onClick={handleUpdate} />
            <button type="button" className="fa fa-close" onClick={onClose} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateICTData;
